import React from "react";
import { MatchesPlaceholder } from "./components/MatchesPlaceholder/MatchesPlaceholder";

function App() {
  return <MatchesPlaceholder />;
}

export default App;
